export const environment = {
  production: false,
  apiUrl: 'https://agroinformer.co'
};